import React, { FC } from 'react';
import { Element } from 'react-scroll';
import Icon from '@common/assets';
import AddButton from '@components/profile/common/addButton';
import PreferContents from '@components/profile/prefer/PreferContents';
import useProfileConditions from '@repository/profiles/useProfileConditions';
import { useUserInfo } from '@repository/auth/useUserInfo';
import { ProfileInfo } from '@domain/constant/profile/ProfileOverlayType';

import classnames from 'classnames/bind';
import styles from './prefer.module.scss';
const cx = classnames.bind(styles);

interface IPreferProps {
  onOpenOverlay: () => void;
}

const Prefer: FC<IPreferProps> = ({ onOpenOverlay }) => {
  const { data: userInfo } = useUserInfo();
  const { data: profileCondition } = useProfileConditions(!!userInfo?.id);

  return (
    <Element name={ProfileInfo.PREFER} className={cx('infoArea')}>
      <div className={cx('sectionTitleArea')}>
        <div className={cx('sectionTitleWrap')}>
          <Icon name="heartLight" width={40} height={40} />
          선호정보
          <span className={cx('require')}>필수</span>
          <span className={cx('infoDesc')}>
            선호하는 직군 · 직무, 근무 지역 등만 입력하면 딱 맞는 공고를 추천해드려요.
          </span>
        </div>

        {/* 입력 버튼 */}
        <AddButton onClick={onOpenOverlay} />
      </div>

      {profileCondition?.saveYn && <PreferContents profileCondition={profileCondition} />}
    </Element>
  );
};

export default Prefer;
